export const filterVisibleDrafts = (drafts) => {
  if (!Array.isArray(drafts)) {
    return [];
  }

  return drafts.filter(
    draft => String(draft?.status || '').toUpperCase() !== 'SUBMITTED'
  );
};
